<script>
    export let message = 'Loan Processing Begins 2026 – Submit your application now to be first in line when we begin disbursements.';
    export let icon = 'fa-circle-info';
    export let closeable = true;

    let visible = true;

    function handleClose() {
        visible = false;
    }
</script>

{#if visible}
    <div class="announcement-banner">
        <div class="announcement-banner__wrapper">
            <div class="announcement-banner__content">
                <i class="fa-solid {icon} announcement-banner__icon"></i>
                <span class="announcement-banner__message">{message}</span>
            </div>
            {#if closeable}
                <button class="announcement-banner__close" on:click={handleClose} aria-label="Close announcement">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    @use 'src/sass/base' as *;

    @keyframes slideDown {
        from {
            transform: translateY(-100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .announcement-banner {
        position: sticky;
        top: 65px;
        z-index: 90;
        width: 100%;
        background: $color-white;
        color: $color-black;
        padding: em(12) em(15);
        border-bottom: 3px solid #007ECA;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        animation: slideDown 0.4s ease-out;

        @include for-tablet-portrait-up {
            padding: em(14) em(20);
        }

        &__wrapper {
            max-width: 1400px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: em(15);
        }

        &__content {
            display: flex;
            align-items: center;
            gap: em(12);
            flex: 1;
            justify-content: center;
            min-width: 0;
        }

        &__icon {
            font-size: em(18);
            flex-shrink: 0;
            color: #007ECA;

            @include for-tablet-portrait-up {
                font-size: em(20);
            }
        }

        &__message {
            font-size: em(13);
            font-weight: $fw-medium;
            line-height: 1.4;
            text-align: center;
            color: $color-black;

            @include for-tablet-portrait-up {
                font-size: em(15);
            }

            @include for-tablet-landscape-up {
                font-size: em(16);
            }
        }

        &__close {
            background: rgba(0, 0, 0, 0.05);
            border: none;
            border-radius: 50%;
            color: $color-gray-text;
            cursor: pointer;
            width: em(28);
            height: em(28);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: em(14);
            transition: all 0.2s ease;
            flex-shrink: 0;

            &:hover {
                background: rgba(0, 0, 0, 0.1);
                color: $color-black;
                transform: scale(1.1);
            }

            &:active {
                transform: scale(0.95);
            }

            &:focus {
                outline: 2px solid $color-primary;
                outline-offset: 2px;
            }
        }
    }
</style>
